import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/ops/support/')({
  component: () => (
    <div className="flex h-full items-center justify-center rounded-lg border border-dashed border-border p-8 text-muted-foreground">
      Select a conversation, or press j to open the first one.
    </div>
  ),
})
